<div class="w-full min-h-screen bg-white p-3 md:p-5">
    <p-toast></p-toast>
  
    <div class="flex flex-column md:flex-row justify-content-between align-items-center gap-3 mb-5">
      <span class="p-input-icon-left w-full md:w-auto">
        <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
               placeholder="Buscar modelo..." class="w-full md:w-20rem border-round-3xl" />
      </span>
      <button pButton label="Nuevo Modelo" icon="pi pi-plus" class="p-button-black border-round-3xl" (click)="openNew()"></button>
    </div>
  
    <p-table #dt [value]="modelos" [rows]="10" [paginator]="true" [globalFilterFields]="['name', 'categoryName']"
             [loading]="loading" [rowHover]="true" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr class="uppercase text-xs text-500">
          <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
          <th pSortableColumn="categoryName">Categoría <p-sortIcon field="categoryName"></p-sortIcon></th>
          <th class="text-center">Estado</th>
          <th class="text-center">Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr class="text-sm">
          <td class="font-bold text-900">{{item.name}}</td>
          <td class="text-600">{{item.categoryName}}</td>
          <td class="text-center">
            <span [class]="'text-xs font-bold px-2 py-1 border-round ' + (item.isActive ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700')">
              {{item.isActive ? 'ACTIVO' : 'INACTIVO'}}
            </span>
          </td>
          <td class="text-center">
            <div class="flex justify-content-center gap-2">
              <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded text-600" (click)="edit(item)"></button>
              <button pButton icon="pi pi-power-off" class="p-button-text p-button-rounded"
                      [ngClass]="item.isActive ? 'text-red-400' : 'text-green-400'" (click)="toggle(item)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  
    <p-dialog [(visible)]="dialog" header="Detalles del Modelo" [modal]="true" [style]="{width: '450px'}" styleClass="p-fluid">
      <div class="flex flex-column gap-3 pt-2">
        <div class="field">
          <label class="font-bold">Categoría</label>
          <p-select [options]="categories" [(ngModel)]="modelo.categoryId" placeholder="Selecciona una categoría" appendTo="body" styleClass="w-full"></p-select>
          <small class="p-error" *ngIf="submitted && !modelo.categoryId">Categoría requerida.</small>
        </div>
        <div class="field">
          <label class="font-bold">Nombre del Modelo</label>
          <input pInputText [(ngModel)]="modelo.name" required autofocus />
          <small class="p-error" *ngIf="submitted && !modelo.name">Nombre requerido.</small>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text text-900" (click)="dialog = false"></button>
        <button pButton label="Guardar" icon="pi pi-check" class="p-button-black" (click)="save()"></button>
      </ng-template>
    </p-dialog>
  </div>